export async function instantiate(module, imports = {}) {
  const __module0 = imports["sm.host"];
  const adaptedImports = {
    env: Object.setPrototypeOf({
      abort(message, fileName, lineNumber, columnNumber) {
        // ~lib/builtins/abort(~lib/string/String | null?, ~lib/string/String | null?, u32?, u32?) => void
        message = __liftString(message >>> 0);
        fileName = __liftString(fileName >>> 0);
        lineNumber = lineNumber >>> 0;
        columnNumber = columnNumber >>> 0;
        (() => {
          // @external.js
          throw Error(`${message} in ${fileName}:${lineNumber}:${columnNumber}`);
        })();
      },
    }, Object.assign(Object.create(globalThis), imports.env || {})),
    "sm.host": Object.setPrototypeOf({
      random_bytes(dstPtr, n) {
        // src/runtime/ports/random_bytes(usize, u32) => void
        dstPtr = dstPtr >>> 0;
        n = n >>> 0;
        __module0.random_bytes(dstPtr, n);
      },
      decode_text(dataPtr, dataLen, charset) {
        // src/runtime/ports/decode_text(usize, u32, ~lib/string/String) => ~lib/string/String
        dataPtr = dataPtr >>> 0;
        dataLen = dataLen >>> 0;
        charset = __liftString(charset >>> 0);
        return __lowerString(__module0.decode_text(dataPtr, dataLen, charset)) || __notnull();
      },
    }, __module0),
  };
  const { exports } = await WebAssembly.instantiate(module, adaptedImports);
  const memory = exports.memory || imports.env.memory;
  const adaptedExports = Object.setPrototypeOf({
    CORE_VERSION: {
      // src/index/CORE_VERSION: ~lib/string/String
      valueOf() { return this.value; },
      get value() {
        return __liftString(exports.CORE_VERSION.value >>> 0);
      }
    },
    sm_version() {
      // src/index/sm_version() => ~lib/string/String
      return __liftString(exports.sm_version() >>> 0);
    },
    sm_init(configJson) {
      // src/index/sm_init(~lib/string/String) => i32
      configJson = __lowerString(configJson) || __notnull();
      return exports.sm_init(configJson);
    },
    account_add(json) {
      // src/index/account_add(~lib/string/String) => i32
      json = __lowerString(json) || __notnull();
      return exports.account_add(json);
    },
    account_update(id, json) {
      // src/index/account_update(i32, ~lib/string/String) => i32
      json = __lowerString(json) || __notnull();
      return exports.account_update(id, json);
    },
    account_list() {
      // src/index/account_list() => ~lib/string/String
      return __liftString(exports.account_list() >>> 0);
    },
    op_start(kind, argsJson) {
      // src/index/op_start(~lib/string/String, ~lib/string/String) => i32
      kind = __retain(__lowerString(kind) || __notnull());
      argsJson = __lowerString(argsJson) || __notnull();
      try {
        return exports.op_start(kind, argsJson);
      } finally {
        __release(kind);
      }
    },
    op_status(opId) {
      // src/index/op_status(i32) => ~lib/string/String
      return __liftString(exports.op_status(opId) >>> 0);
    },
    op_effects() {
      // src/index/op_effects() => ~lib/string/String
      return __liftString(exports.op_effects() >>> 0);
    },
    op_feed(kind, dataJson) {
      // src/index/op_feed(~lib/string/String, ~lib/string/String) => i32
      kind = __retain(__lowerString(kind) || __notnull());
      dataJson = __lowerString(dataJson) || __notnull();
      try {
        return exports.op_feed(kind, dataJson);
      } finally {
        __release(kind);
      }
    },
  }, exports);
  function __liftString(pointer) {
    if (!pointer) return null;
    const
      end = pointer + new Uint32Array(memory.buffer)[pointer - 4 >>> 2] >>> 1,
      memoryU16 = new Uint16Array(memory.buffer);
    let
      start = pointer >>> 1,
      string = "";
    while (end - start > 1024) string += String.fromCharCode(...memoryU16.subarray(start, start += 1024));
    return string + String.fromCharCode(...memoryU16.subarray(start, end));
  }
  function __lowerString(value) {
    if (value == null) return 0;
    const
      length = value.length,
      pointer = exports.__new(length << 1, 2) >>> 0,
      memoryU16 = new Uint16Array(memory.buffer);
    for (let i = 0; i < length; ++i) memoryU16[(pointer >>> 1) + i] = value.charCodeAt(i);
    return pointer;
  }
  const refcounts = new Map();
  function __retain(pointer) {
    if (pointer) {
      const refcount = refcounts.get(pointer);
      if (refcount) refcounts.set(pointer, refcount + 1);
      else refcounts.set(exports.__pin(pointer), 1);
    }
    return pointer;
  }
  function __release(pointer) {
    if (pointer) {
      const refcount = refcounts.get(pointer);
      if (refcount === 1) exports.__unpin(pointer), refcounts.delete(pointer);
      else if (refcount) refcounts.set(pointer, refcount - 1);
      else throw Error(`invalid refcount '${refcount}' for reference '${pointer}'`);
    }
  }
  function __notnull() {
    throw TypeError("value must not be null");
  }
  return adaptedExports;
}
